import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Handshake, BadgeDollarSign, MapPin } from 'lucide-react';
const reasons = [{
  title: 'Independent Agents',
  description: 'We work for you, not the insurance companies. We provide unbiased advice to find what truly fits your needs.',
  icon: Handshake
}, {
  title: '20+ Top Carriers',
  description: 'Access to a wide network of highly-rated insurance providers means more options and better rates for you.',
  icon: ShieldCheck
}, {
  title: 'No-Cost Consultation',
  description: 'Our services are 100% free to you. You pay the exact same premium as if you went directly to the carrier.',
  icon: BadgeDollarSign
}, {
  title: 'Local & Licensed',
  description: 'We understand the specific healthcare networks and insurance regulations in your local area.',
  icon: MapPin
}];
export function WhyChooseUs() {
  return <section id="about" className="py-24 bg-white" data-id="element-335">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-336">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-337">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-338">
            <h2 className="text-4xl font-bold mb-6" data-id="element-339">
              Why work with KRT Insurance?
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-340">
              Navigating insurance can be overwhelming. As an independent
              agency, we simplify the process by doing the heavy lifting for
              you. We compare plans, explain the fine print, and advocate on
              your behalf—all at no extra cost to you.
            </p>

            <div className="grid sm:grid-cols-2 gap-8" data-id="element-341">
              {reasons.map((reason, index) => {
              const Icon = reason.icon;
              return <div key={index} className="flex flex-col" data-id="element-342">
                    <div className="w-10 h-10 bg-accent/20 rounded-lg flex items-center justify-center mb-4" data-id="element-343">
                      <Icon className="w-5 h-5 text-navy-dark" data-id="element-344" />
                    </div>
                    <h4 className="text-lg font-bold text-navy mb-2" data-id="element-345">
                      {reason.title}
                    </h4>
                    <p className="text-slate-600 text-sm leading-relaxed" data-id="element-346">
                      {reason.description}
                    </p>
                  </div>;
            })}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative h-[600px] rounded-3xl overflow-hidden shadow-2xl" data-id="element-347">
            <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Insurance agent discussing plans with clients" className="absolute inset-0 w-full h-full object-cover" data-id="element-348" />
            {/* Overlay gradient for text readability if we wanted to add text over image */}
            <div className="absolute inset-0 bg-gradient-to-t from-navy/80 via-navy/20 to-transparent" data-id="element-349"></div>

            <div className="absolute bottom-8 left-8 right-8 bg-white/95 backdrop-blur p-6 rounded-2xl shadow-lg" data-id="element-350">
              <div className="flex items-center gap-4" data-id="element-351">
                <div className="w-12 h-12 bg-accent rounded-full flex items-center justify-center flex-shrink-0" data-id="element-352">
                  <ShieldCheck className="w-6 h-6 text-navy-dark" data-id="element-353" />
                </div>
                <div data-id="element-354">
                  <p className="font-bold text-navy" data-id="element-355">Licensed & Certified</p>
                  <p className="text-sm text-slate-600" data-id="element-356">
                    Our agents undergo rigorous annual training.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}